export enum EExcelConnectorViewStatus {
    EMPTY,
    UNSELECT,
    EDIT
}
